import {useQuery} from '@tanstack/react-query';
import {apiClient} from '../../../../lib/api-client';
import {MaterialOption} from "../types/MaterialOption";

const emptyArray: MaterialOption[] = [];

export const useCompareMaterialOptions = (dealerID: number, products: number[], quoteId: string, zipCode: string) => {
    const {data, isLoading} = useQuery({
        queryKey: ['ee-tool-compare-material-options', dealerID, quoteId ?? '', products.length > 0 ? products[0] : ''],
        queryFn: async () => await apiClient.get('ee-tool/compare-material-options?dealerID=' + dealerID + '&productID=' + products[0] + '&quoteID=' + quoteId + '&zipCode=' + zipCode) as MaterialOption[],
        enabled: products.length > 0,
        staleTime: 5 * 60 * 1000
    });

    return {
        data: data || emptyArray,
        isLoading: isLoading
    };
};
